import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/RulePreview.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/private/preview`;
	}
	preview(e, t) {
		return this.api.post(this.buildPath(n.baseUrl, { ruleId: t }), e);
	}
};
//#endregion
export { n as RulePreview };

//# sourceMappingURL=RulePreview.js.map